<template>
    <div class="privaatsuspoliitika">
      <strong>Rocca al Mare Tennisekeskus OÜ on võtnud endale kohustuse kaitsta klientide ja kasutajate privaatsust ning kinnitame, et oleme täitnud määruse sätted ja kindlustame Teie isikuandmete läbipaistva ja ausa töötlemise.</strong>
      <br/><br/>
      <strong>Isikuandmete töötlemine</strong>
      <p>
        Veebipoe Rocca al Mare Tennisekeskuse Iseteeninduskeskkonna isikuandmete vastutav töötleja on iseteenindus.tenniseklubi.ee (registrikood 12096075) asukohaga Haabersti tn 5, Tallinn, Harju maakond,  tel <a href="tel:+3726600526">+372 660 0526</a> ja e-kiri
        <a href="mailto:info@tenniseklubi.ee">info@tenniseklubi.ee</a>. Vastutav töötleja on määranud andmekaitsespetsialisti, kelle kontaktandmed on: tel <a href="tel:+3726600526">+372 660 0526</a> ja e-kiri <a href="mailto:info@tenniseklubi.ee">info@tenniseklubi.ee</a>.<br/>
        Rocca al Mare Tennieskeskus OÜ on isikuandmete vastutav töötleja. Rocca al Mare Tennieskeskus OÜ edastab maksete teostamiseks vajalikud isikuandmed volitatud töötleja Maksekeskus AS-le.
      </p>

      <strong>Milliseid isikuandmeid töödeldakse</strong>
      <ol>
        <li>nimi, telefoninumber ja e-posti aadress;</li>
        <li>kaupade ja teenuste maksumus ja maksetega seotud andmed (ostuajalugu);</li>
        <li>klienditoe andmed</li>
      </ol>

      <strong>Mis eesmärgil isikuandmeid töödeldakse</strong>
      <ol>
        <li>Isikuandmeid kasutatakse kliendi tellimuste haldamiseks</li>
        <li>Isikuandmeid nagu e-post, telefoni nr, kliendi nimi, töödeldakse selleks, et lahendada teenuste osutamisega seonduvaid küsimusi (klienditugi).</li>
        <li>Ostuajaloo andmeid (ostu kuupäev, kaup, kogus, kliendi andmed) kasutatakse ostetud kaupade ja teenuste ülevaate koostamiseks ning kliendieelistuste analüüsimiseks, kuid siinkohal on oluline mainida, et tööprotsessis kasutame enamjaolt isikustamata andmeid (s.t ei ole võimalik tuvastada, kas andmed käivad Teie kohta või mitte)</li>
        <li>E-maili ja komminikeerimise nõusoleku infot kasutatakse, et teavitada Teid eripakkumistest, anda Teile teavet uudiste, korraldatavate ürituste, kampaaniate ja projektide kohta</li>
      </ol>

      <strong>Õiguslik alus</strong>
      <p>
        Isikuandmete töötlemine toimub kliendiga sõlmitud teenuse osutamise lepingu täitmise eesmärgil.<br/>
        Isikuandmete töötlemine toimub juriidilise kohustuse täitmiseks (nt raamatupidamine ja tarbijavaidluste lahendamine).<br/>
      </p>

      <strong>Vastuvõtjad, kellele isikuandmed edastatakse</strong>
      <p>
        Isikuandmed edastatakse veebipoe klienditoele ostude ja ostuajaloo haldamiseks ja kliendiprobleemide lahendamiseks.<br/>
        Kui veebipoe raamatupidamine toimub teenusepakkuja poolt, siis edastatakse isikuandmed teenusepakkujale raamatupidamistoimingute tegemiseks.<br/>
        Isikuandmeid võidakse edastada infotehnoloogia teenuste pakkujatele, kui see on vajalik veebipoe funktsionaalsuse või andmemajutuse tagamiseks.<br/>
      </p>

      <strong>Turvalisus ja andmetele ligipääs</strong>
      <p>
        Isikuandmeid hoitakse Zone virtuaalserveris, mis asuvad Euroopa Liidu liikmesriigi või Euroopa Liidu majanduspiirkonnaga liitunud riikide territooriumil. Andmeid võidakse edastada riikidesse, mille andmekaitse taset on Euroopa Komisjon hinnanud piisavaks ning USA ettevõtetele, kes on liitund andmekaitse kilbi (Privacy Shield) raamistikuga.<br/>
        Juurdepääs isikuandmetele on veebipoe töötajatel, kes saavad isikuandmetega tutvuda selleks, et lahendada veebipoe kasutamisega seonduvaid tehnilisi küsimusi ning osutada klienditoe teenust.<br/>
        Veebipood rakendab asjakohaseid füüsilisi, organisatsioonilisi ja infotehnilisi turvameetmeid, et kaitsta isikuandmeid juhusliku või ebaseadusliku hävitamise, kaotsimineku, muutmise või loata juurdepääsu ja avalikustamise eest.<br/>
        Isikuandmete edastamine veebipoe volitatud töötlejatele (nt transporditeenuse pakkuja ja andmemajutus) toimub veebipoe ja volitatud töötlejatega sõlmitud lepingute alusel. Volitatud töötlejaid on kohustatud tagama isikuandmete töötlemisel asjakohased kaitsemeetmed.<br/>
      </p>

      <strong>Isikuandmetega tutvumine ja parandamine </strong>
      <p>
        Isikuandmetega saab tutvuda ja teha parandusi veebipoe kasutajaprofiilis.
      </p>

      <strong>Nõusoleku tagasivõtmine </strong>
      <p>
        Kui isikundmete töötlemine toimub kliendi nõusoleku alusel, siis on kliendil õigus nõusolek tagasi võtta teavitades sellest kliendituge e-posti teel.
      </p>

      <strong>Säilitamine</strong>
      <p>
        Veebipoe kliendikonto sulgemisel kustutatakse isikuandmed, va juhul kui selliseid andmeid on vaja säilitada raamatupidamise jaoks või tarbijavaidluste lahendamiseks.<br/>
        Maksetega ja tarbijavaidlustega seotud vaidluste korral säilitatakse isikuandmed kuni nõude täitmiseni või aegumistähtaja lõpuni.<br/>
        Raamatupidamise jaoks vajalikud isikuandmed säilitatakse seitse aastat.<br/>
      </p>

      <strong>Kustutamine</strong>
      <p>
        Isikuandmete kustutamiseks tuleb võtta ühendust klienditoega e-posti teel. Kustutamistaotlusele vastatakse mitte hiljem kui kuu aja jooksul ning täpsustakse andmete kustutamise perioodi.
      </p>

      <strong>Otseturustusteated</strong>
      <p>
        E-kirja aadressi ja telefoninumbrit kasutatakse otseturundusteadete saatmiseks, kui klient on andnud vastava nõusoleku. Kui klient ei soovi saada otseturustusteateid, siis tuleb valida e-kirja jaluses vastav viide või võtta ühendust klienditoega.
      </p>

      <strong>Vaidluste lahendamine </strong>
      <p>
        Isikuandmete töötlemisega seotud vaidluste lahendamine toimub klienditoe vahendusel e-mailil <a href="mailto:info@tenniseklubi.ee">info@tenniseklubi.ee</a>. Järelevalveasutus on Eesti Andmekaitse Inspektsioon (<a
        href="mailto:info@aki.ee">info@aki.ee</a>).
      </p>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                title: 'Privaatsuspoliitika',
            }
        }
    }
</script>

<style lang="scss" scoped>
  .privaatsuspoliitika {
    width: 60%; margin:  0 auto; text-align: left;
    strong {font-weight: 600;}
    ol {margin-bottom: 20px;}
  }
</style>



// WEBPACK FOOTER //
// src/views/Privaatsuspoliitika.vue